/** @file routePuppet: the puppet id a route names (pose, art, agent), else null. */
import type { Route } from '../state/editorTypes';

/** `{ screen: 'art', puppetId }` → `puppetId`; projects, a project's puppets and settings name none. */
export function routePuppet(route: Route): string | null {
  return route.screen === 'pose' || route.screen === 'art' || route.screen === 'agent' || route.screen === 'tile' ? route.puppetId : null;
}
